import React from 'react';
import { ArrowLeft, Home } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const fuzouCategories = [
  {
    id: 'hushen',
    title: '金光护身咒',
    desc: '不顺时，身体不好时，大声的说出来',
    route: '/fuzou/hushen',
    color: 'from-amber-500 to-orange-500'
  },
  {
    id: 'beidou',
    title: '北斗咒',
    desc: '驱邪避凶，北斗保身',
    route: '/fuzou/beidou',
    color: 'from-blue-500 to-indigo-500'
  },
  {
    id: 'zhanjiang',
    title: '斩江咒',
    desc: '镇宅护平安',
    route: '/fuzou/zhanjiang',
    color: 'from-red-500 to-rose-500'
  },
  {
    id: 'xianglong',
    title: '降龙咒',
    desc: '降服天龙，镇宅安宅',
    route: '/fuzou/xianglong',
    color: 'from-purple-500 to-pink-500'
  },
  {
    id: 'fuhua',
    title: '伏虎咒',
    desc: '降服白虎，护身平安',
    route: '/fuzou/fuhua',
    color: 'from-green-500 to-teal-500'
  },
  {
    id: 'tianshen',
    title: '天神咒',
    desc: '祈求天神保佑',
    route: '/fuzou/tianshen',
    color: 'from-cyan-500 to-blue-500'
  },
  {
    id: 'disan',
    title: '地祇咒',
    desc: '祭祀地祇，保家安宁',
    route: '/fuzou/disan',
    color: 'from-emerald-500 to-green-500'
  },
  {
    id: 'yinshen',
    title: '隐身咒',
    desc: '护身隐身，趋吉避凶',
    route: '/fuzou/yinshen',
    color: 'from-slate-500 to-gray-500'
  }
];

const FuzouList = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-50 to-indigo-50 flex flex-col">
      <div className="flex-grow flex flex-col items-center py-12 px-4">
        <div className="w-full max-w-4xl">
          {/* 返回按钮和首页链接 */}
          <div className="flex items-center justify-between mb-8">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center text-purple-800 hover:text-purple-600 transition-colors"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              返回
            </button>
            <Link
              to="/"
              className="flex items-center text-purple-800 hover:text-purple-600 transition-colors"
            >
              <Home className="w-5 h-5 mr-2" />
              首页
            </Link>
          </div>

          <h1 className="text-4xl font-bold text-center text-purple-900 mb-4 font-serif">
            道 教 八 大 名 咒
          </h1>
          <p className="text-center text-gray-500 mb-12">道家真言，趋吉避凶</p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {fuzouCategories.map((item) => (
              <Link
                key={item.id}
                to={item.route}
                className="group bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden"
              >
                <div className={`h-2 bg-gradient-to-r ${item.color}`}></div>
                <div className="p-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-xl font-bold text-purple-900 mb-1">{item.title}</h3>
                      <p className="text-gray-500 text-sm">{item.desc}</p>
                    </div>
                    <ArrowRight className="w-5 h-5 text-purple-300 group-hover:text-purple-600 transition-colors" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FuzouList;
